<div class="d-flex border border-dark rounded p-4">
    <div>
        <div class="text-s font-semi-bold text-default mb-2">{{ formQuestion.value.title }}</div>
        <div class="text-xs font-semi-bold text-muted">
            {{ 'v3-byoc-popup-create-episode-questions-answers' | translate: { count: answersCount } }}
        </div>
    </div>
    <div
        [ariaLabel]="'v3-byoc-popup-create-episode-edit-question' | translate"
        tabbable
        role="button"
        (enterKeyUp)="editClick()"
        (click)="editClick()"
        class="icon icon-l ms-auto me-2"
        [ngClass]="[editing ? 'icon-muted' : 'icon-default icon-hover-info pointer']"
        inlineSVG="assets/icons.svg#edit-pen"
        buttonDataTest="editQuestionButton"
    ></div>
    <div
        [ariaLabel]="'v3-byoc-popup-create-episode-delete-question' | translate"
        tabbable
        role="button"
        (enterKeyUp)="deleteClick()"
        (click)="deleteClick()"
        buttonDataTest="deleteQuestionButton"
        class="icon icon-l"
        [ngClass]="[editing ? 'icon-muted' : 'icon-default icon-hover-danger pointer']"
        inlineSVG="assets/icons.svg#trash-alt"
    ></div>
</div>
